import { render, staticRenderFns } from "./OarPendingAged30dSummary.vue?vue&type=template&id=63525efa&scoped=true"
import script from "./OarPendingAged30dSummary.vue?vue&type=script&lang=js"
export * from "./OarPendingAged30dSummary.vue?vue&type=script&lang=js"
import style0 from "./OarPendingAged30dSummary.vue?vue&type=style&index=0&id=63525efa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63525efa",
  null
  
)

export default component.exports